export const CSRF_COOKIE_NAME = '_csrf_token'
export const HOST = 'https://foxford.ru'
